import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Appointment } from '../../../../shared/state/appointment/appointment.model';
import { GenericKeysModel } from '../../../../shared/models';

@Component({
    selector: 'app-appointment-item',
    templateUrl: './appointment-item.component.html',
    styleUrls: ['./appointment-item.component.scss'],
})
export class AppointmentItemComponent implements OnInit {
    @Input() appointment: Appointment;
    @Input() genericKey: number;
    @Input() appDelegate: boolean;
    @Output() trashClickedEvent = new EventEmitter<Appointment>();

    genericKeyVoooy = GenericKeysModel.Voooy;

    constructor() {}

    ngOnInit(): void {}

    onTrashClicked(appointment: Appointment) {
        this.trashClickedEvent.emit(appointment);
    }
}
